<div class="page-wrapper">
  @if (isLoading()) {
    <korviu-loader />
  } @else if (paymentDetails(); as payment) {
    <go-back class="block my-8 md:hidden" />
    <nav class="payment-breadcrumb flex flex-wrap items-center text-[1.125rem]/[1.6] mb-6" aria-label="breadcrumb">
      <a class="color-neutral-400 font-normal" [routerLink]="['/workspace', 'balance']">{{
        'balance.accountBalance' | translate
      }}</a>
      <span class="payment-breadcrumb-separator color-neutral-400" aria-hidden="true">/</span>
      <span class="payment-breadcrumb-current font-medium" aria-current="page">{{ pageTitleKey() | translate }}</span>
    </nav>
    <div class="flex flex-col md:flex-row gap-4">
      <div class="px-4 py-6 flex flex-col items-center gap-2 applied-balance flex-1">
        <div class="font-bold text-[2.0625rem]/[2.8875rem]" data-payment-field="monthResult">
          @if (paymentResultAmount() !== null) {
            {{ paymentResultAmount() | balanceMoney }}
            USD
          } @else {
            —
          }
        </div>
        <div class="flex gap-2 items-center">
          <div class="status-text">{{ 'balance.status' | translate }}:</div>
          <div>
            <app-tag [type]="paymentStatusTagType()">
              {{ paymentStatusTranslationKey() | translate }}
            </app-tag>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-2 p-8 items-center active-okeey-cash-account flex-1">
        <div class="text-[2.0625rem]/[2.8875rem] font-bold active-okeey-cash-account-value">
          {{ totalLeaves() === null ? '—' : (totalLeaves() | number: '1.0-0' : language()) }}
          {{ 'balance.leaves' | translate }}
        </div>
        <div class="active-okeey-cash-account-name">
          {{ 'balance.activeOkeeyCashAccounts' | translate }}
        </div>
      </div>
    </div>
    @if (isProvisional()) {
      <app-alert
        class="mt-4"
        role="status"
        type="info"
        localizableText="balance.commissionsPreviewNotice"
        [closable]="false"
        data-commissions-preview
      />
    }
    @if (paymentAlert(); as alert) {
      <app-alert
        class="mt-4"
        role="status"
        [type]="alert.type"
        [localizableText]="alert.key"
        [closable]="false"
        data-payment-alert
      />
    }
    <div class="w-full flex p-4 md:p-6 rounded-lg gap-3 payments-widget mt-4">
      <div class="flex flex-col items-center gap-1 flex-1">
        <i>
          <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
            <path
              d="M22.8307 2.66797C25.2239 2.66797 27.1641 4.60806 27.1641 7.0013V14.697C26.5465 14.3017 25.8754 13.9824 25.1641 13.7526V10.0013H5.16406V22.3346C5.16406 23.6233 6.20873 24.668 7.4974 24.668H14.2487C14.4785 25.3793 14.7978 26.0504 15.1931 26.668H7.4974C5.10416 26.668 3.16406 24.7278 3.16406 22.3346V7.0013C3.16406 4.60806 5.10416 2.66797 7.4974 2.66797H22.8307ZM22.8307 4.66797H7.4974C6.20873 4.66797 5.16406 5.71264 5.16406 7.0013V8.0013H25.1641V7.0013C25.1641 5.71264 24.1194 4.66797 22.8307 4.66797ZM29.8307 22.0013C29.8307 26.0514 26.5475 29.3346 22.4974 29.3346C18.4473 29.3346 15.1641 26.0514 15.1641 22.0013C15.1641 17.9512 18.4473 14.668 22.4974 14.668C26.5475 14.668 29.8307 17.9512 29.8307 22.0013ZM26.9689 18.8632C26.7085 18.6029 26.2863 18.6029 26.0259 18.8632L21.1641 23.7252L18.9689 21.5298C18.7085 21.2696 18.2863 21.2696 18.0259 21.5298C17.7657 21.7902 17.7657 22.2124 18.0259 22.4728L20.6926 25.1394C20.953 25.3997 21.3751 25.3997 21.6355 25.1394L26.9689 19.8061C27.2291 19.5457 27.2291 19.1236 26.9689 18.8632Z"
              fill="#007DCB"
            />
          </svg>
        </i>
        <div class="text-[1rem]/[1.6rem] font-light color-secondary-500">
          {{ 'balance.period' | translate }}
        </div>
        <div class="text-[1.375rem]/[2.2rem] font-bold color-secondary-900">
          {{ paymentPeriodLabel() }}
        </div>
      </div>
      @if (!isProvisional()) {
        <div class="block w-[1px] background-neutral-50"></div>
        <div class="flex flex-col items-center gap-1 flex-1">
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" width="33" height="32" viewBox="0 0 33 32" fill="none">
              <path
                d="M19.6409 3.45915C19.7593 3.30884 19.9797 3.28886 20.1233 3.41542L21.3513 4.49834L17.4844 9.33203H20.0456L22.8531 5.82266L25.056 7.76522C25.1915 7.8847 25.2072 8.09034 25.0913 8.22896L24.1697 9.33203H26.762C27.4207 8.3706 27.2704 7.05134 26.3788 6.26515L21.4461 1.91535C20.4415 1.02943 18.8988 1.16931 18.07 2.22148L12.4683 9.33203H15.0144L19.6409 3.45915ZM22.1667 18.6654C21.6144 18.6654 21.1667 19.1131 21.1667 19.6654C21.1667 20.2176 21.6144 20.6654 22.1667 20.6654H24.8333C25.3856 20.6654 25.8333 20.2176 25.8333 19.6654C25.8333 19.1131 25.3856 18.6654 24.8333 18.6654H22.1667ZM6.5 9.66536C6.5 9.11308 6.94772 8.66536 7.5 8.66536H11.6713L13.26 6.66536H7.5C5.84315 6.66536 4.5 8.00851 4.5 9.66536V23.6654C4.5 26.0586 6.44009 27.9987 8.83333 27.9987H24.8333C27.2265 27.9987 29.1667 26.0586 29.1667 23.6654V14.9987C29.1667 12.6055 27.2265 10.6654 24.8333 10.6654H7.5C6.94772 10.6654 6.5 10.2176 6.5 9.66536ZM6.5 23.6654V12.4947C6.81277 12.6052 7.14936 12.6654 7.5 12.6654H24.8333C26.122 12.6654 27.1667 13.71 27.1667 14.9987V23.6654C27.1667 24.954 26.122 25.9987 24.8333 25.9987H8.83333C7.54467 25.9987 6.5 24.954 6.5 23.6654Z"
                fill="#D95B01"
              />
            </svg>
          </i>
          <div class="text-[1rem]/[1.6rem] font-light color-warning-600">
            {{ 'balance.paymentDueDate' | translate }}
          </div>
          <div class="text-[1.375rem]/[2.2rem] font-bold color-warning-900">
            {{ paymentDueDateLabel() }}
          </div>
        </div>
      }
    </div>
    @if (!isProvisional() && payment.paid_date) {
      <div class="summary-text mt-4 text-center">
        {{ 'balance.paymentDate' | translate }}: {{ paymentPaidDateLabel() }}
      </div>
    }
    @if (paymentStatus() === 'Held') {
      <p class="summary-text mt-4" role="status">{{ 'balance.paymentHeldNotice' | translate }}</p>
    }
    <!-- Download Payment renders as in the design. It stays disabled until the backend exposes
         the statement PDF, and the payload carries has_proof_of_payment without a URL. -->
    @if (!isProvisional()) {
      <div class="w-full mt-4">
        <korviu-button color="primary" [disabled]="true">
          <div class="flex gap-2">
            <div>{{ 'balance.downloadPayment' | translate }}</div>
            <i>
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  d="M6.5 2C5.39543 2 4.5 2.89543 4.5 4V11.4982C4.97417 11.3004 5.47679 11.1572 6 11.0764V4C6 3.72386 6.22386 3.5 6.5 3.5H12.5V8C12.5 9.10457 13.3954 10 14.5 10H19V20C19 20.2761 18.7761 20.5 18.5 20.5H12.7678C12.4806 21.051 12.1168 21.5557 11.6904 22H18.5C19.6046 22 20.5 21.1046 20.5 20V9.82777C20.5 9.29733 20.2893 8.78863 19.9142 8.41355L14.0864 2.58579C13.7114 2.21071 13.2027 2 12.6722 2H6.5ZM17.8793 8.5H14.5C14.2239 8.5 14 8.27614 14 8V4.62066L17.8793 8.5ZM12.5 17.5C12.5 20.5376 10.0376 23 7 23C3.96243 23 1.5 20.5376 1.5 17.5C1.5 14.4624 3.96243 12 7 12C10.0376 12 12.5 14.4624 12.5 17.5ZM7.5 14.5C7.5 14.2239 7.27614 14 7 14C6.72386 14 6.5 14.2239 6.5 14.5V19.2929L4.85355 17.6464C4.65829 17.4512 4.34171 17.4512 4.14645 17.6464C3.95118 17.8417 3.95118 18.1583 4.14645 18.3536L6.64645 20.8536C6.84171 21.0488 7.15829 21.0488 7.35355 20.8536L9.85355 18.3536C10.0488 18.1583 10.0488 17.8417 9.85355 17.6464C9.65829 17.4512 9.34171 17.4512 9.14645 17.6464L7.5 19.2929V14.5Z"
                  fill="#FCFCFC"
                />
              </svg>
            </i>
          </div>
        </korviu-button>
      </div>
    }
    <!-- Payment Breakdown -->
    <div class="mt-8">
      <h2 class="text-[1.75rem]/[2.45rem] font-bold text-center p-0 mb-6">
        {{ (isProvisional() ? 'balance.commissionsBreakdown' : 'balance.paymentBreakdown') | translate }}
      </h2>
      <div class="w-full rounded-xl shadow-md text-gray-800">
        <div class="summary-bg text-[0.8125rem]/[1.3rem] px-6 py-2 font-bold rounded-t-xl">
          {{ 'balance.summary' | translate }}
        </div>
        <div class="px-6">
          @for (row of breakdownRows(); track row.key) {
            <div class="flex justify-between gap-4 summary-text py-3" [attr.data-payment-field]="row.key">
              <span class="flex-1">{{ 'balance.' + row.key | translate }}</span>
              <span class="text-right">
                {{ row.amount | balanceMoney }}
              </span>
            </div>
          }
        </div>
        <div
          class="amount-due px-6 py-3 flex justify-between gap-4 summary-text font-bold"
          data-payment-field="totalPayout"
        >
          <span>{{ (isProvisional() ? 'balance.projectedPayment' : 'balance.yourPayment') | translate }}</span>
          <span>
            {{ totalPayout() | balanceMoney }}
          </span>
        </div>
      </div>
    </div>
    <!-- Member Contributions: direct referrals only, each carrying earnings from its whole community branch. -->
    <section class="mt-8 mb-8">
      <h2 class="text-[1.75rem]/[2.45rem] font-bold mb-2 text-center">
        {{ 'balance.memberContributions' | translate }}
      </h2>
      <div class="color-secondary-500 text-[1.125rem]/[1.8rem] mb-6 text-center">
        {{ 'balance.directReferrals' | translate }}
      </div>
      @if (hasMemberContributions()) {
        <korviu-list [config]="memberListConfig" />
        @if (filteredContributionsTotal() !== null) {
          <div
            class="flex items-center justify-center gap-2 text-[1.125rem]/[1.6] color-neutral-500 mt-6"
            data-payment-field="memberContributionsTotal"
          >
            <span class="font-bold">{{ 'balance.totalContribution' | translate }}</span>
            <span>{{ filteredContributionsTotal() | balanceMoney }}</span>
          </div>
        }
      } @else {
        <p class="summary-text text-center">{{ 'balance.paymentContributionsUnavailable' | translate }}</p>
      }
    </section>
  } @else {
    <go-back class="block my-8 md:hidden" />
    <div class="flex flex-col gap-4 items-center py-10">
      <korviu-no-data />
      <div class="text-[#737980] text-[0.9375rem] text-center">{{ 'balance.paymentDetailsLoadError' | translate }}</div>
      @if (loadError()) {
        <korviu-button color="tertiary" (onclick)="retry()">{{ 'common.tryAgain' | translate }}</korviu-button>
      }
    </div>
  }
</div>
